/**
 * 根据输入的出生日期计算周岁年龄
 * @param {string|Date} birthDate - 出生日期，可以是日期字符串（如'2000/01/01'）或Date对象
 * @returns {number} 周岁年龄
 */
function calculateAge(birthDate) {
  if (!birthDate) {
    return null;
  }
  // 处理输入，转换为Date对象
  const birth = new Date(birthDate);
  // 验证日期有效性
  if (isNaN(birth.getTime())) {
    throw new Error("请输入有效的出生日期");
  }

  const today = new Date();

  // 获取年份、月份、日期
  const birthYear = birth.getFullYear();
  const birthMonth = birth.getMonth();
  const birthDay = birth.getDate();

  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth();
  const currentDay = today.getDate();

  // 计算基础年龄（年份差）
  let age = currentYear - birthYear;

  // 调整月份：如果当前月份小于出生月份，年龄减1
  if (currentMonth < birthMonth) {
    age--;
  }
  // 月份相同但日期小于出生日期，年龄减1
  else if (currentMonth === birthMonth && currentDay < birthDay) {
    age--;
  }

  return age;
}
export { calculateAge };
